<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" fill="none">
    <path
      d="M11.9999 21.5984C6.6974 21.5984 2.3999 17.3009 2.3999 11.9984C2.3999 6.69594 6.6974 2.39844 11.9999 2.39844C17.3024 2.39844 21.5999 6.69594 21.5999 11.9984C21.5999 17.3009 17.3024 21.5984 11.9999 21.5984ZM11.9999 4.19844C7.69115 4.19844 4.1999 7.68969 4.1999 11.9984C4.1999 16.3072 7.69115 19.7984 11.9999 19.7984C16.3087 19.7984 19.7999 16.3072 19.7999 11.9984C19.7999 7.68969 16.3087 4.19844 11.9999 4.19844ZM14.6512 8.76969C14.9437 8.36844 15.5062 8.27844 15.9074 8.57094C16.3087 8.86344 16.3987 9.42594 16.1062 9.82719L11.5274 16.1272C11.3737 16.3409 11.1337 16.4759 10.8712 16.4947C10.6087 16.5134 10.3499 16.4197 10.1662 16.2359L8.0699 14.1397C7.7174 13.7872 7.7174 13.2172 8.0699 12.8684C8.4224 12.5197 8.9924 12.5159 9.34115 12.8684L10.6912 14.2184L14.6512 8.77344V8.76969Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'CreditsIcon',
  props: {
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#484848'
    }
  }
};
</script>
